import { useContext } from 'react';
import { remoteFlags } from '@shd/jslib/ui';
import UserStore from '../services/Session/store';
import {
  FlagsContext,
  WebRemoteConfigParam,
} from '../services/FlagsProvider/FlagsProvider';

export const useRemoteConfigValue = (name: WebRemoteConfigParam) => {
  const context = useContext(FlagsContext);
  const { flags } = context;
  return flags[name];
};

export const useIsFeatureEnabled = <K extends WebRemoteConfigParam>(
  feature: K,
  userContext: UserStore,
  teamIds: string[] = []
) => {
  return remoteFlags.useFeatureEnabled(
    feature,
    FlagsContext,
    userContext.authUser?.claims?.shd_user_id as string | undefined,
    userContext.user?.email as string | undefined,
    userContext.selectedTeam?._id,
    teamIds
  );
};

export const useIsFeatureEnabledValue = <K extends WebRemoteConfigParam>(
  feature: K,
  userContext: UserStore,
  teamIds: string[] = []
) => {
  return remoteFlags.useFeatureEnabledValue(
    feature,
    FlagsContext,
    userContext.authUser?.claims?.shd_user_id as string | undefined,
    userContext.user?.email as string | undefined,
    userContext.selectedTeam?._id,
    teamIds
  );
};
